import type { ComponentProps, ReactNode } from 'react';
import type React from 'react';
import clsx from 'clsx';
import Styles from './DealLayout.module.scss';
import type { Deal } from '~/models/Deal';
import { DealLayoutHeaderClient } from '~/components/common/layouts/deals/DealLayoutHeaderClient';
import { DealLayoutHeaderVendor } from './DealLayoutHeaderVendor';

type Props = {
  deal: Deal;
  children: ReactNode;
  items: ComponentProps<
    typeof DealLayoutHeaderVendor | typeof DealLayoutHeaderClient
  >['items'];
  noBackground?: boolean;
  isVendor?: boolean;
  useSimpleSpHeader?: boolean;
};

export const DealLayout: React.FC<Props> = ({
  deal,
  children,
  items,
  noBackground = false,
  isVendor = false,
  useSimpleSpHeader = false
}: Props) => (
  <div>
    {isVendor ? (
      <DealLayoutHeaderVendor
        deal={deal}
        items={items}
        useSimpleSpHeader={useSimpleSpHeader}
      />
    ) : (
      <DealLayoutHeaderClient
        deal={deal}
        items={items}
        useSimpleSpHeader={useSimpleSpHeader}
      />
    )}
    <div
      className={clsx(
        Styles.Container,
        noBackground ? Styles.Transparent : Styles.White
      )}
    >
      {children}
    </div>
  </div>
);
